import axios from 'axios';
import type {
  IGetOrgContractsByOrgIdParams,
  IGetOrgContractsByOrgIdRequest,
  IGetOrgContractsByOrgIdResponse,
} from '@/app-package';

const getOrgContractsByOrgId = async (
  params: IGetOrgContractsByOrgIdParams,
) => {
  const config: IGetOrgContractsByOrgIdRequest = {
    url: `/supra/org_contracts_without_mlsid/${params.orgId}`,
    method: 'get',
  };
  try {
    const { data } =
      await axios.request<IGetOrgContractsByOrgIdResponse>(config);
    return data;
  } catch (error: any) {
    // Check for 404 error and return an empty array
    if (error.response && error.response.status === 404) {
      return [];
    }
    throw error;
  }
};

export default getOrgContractsByOrgId;
